export default "__VITE_ASSET__Belupvok__"